// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be14758a","239":"b4d6e79c","453":"efbfe00a","667":"8cf7398f"}[chunkId] + ".chunk.js";
};